<button class="cancel-button" (click)="cancelClicked()" nz-button type="button" nzType="default" nzDanger >
  Cancel
</button>